import PropTypes from 'prop-types';
import React from 'react';
import { roundPrice } from 'lib/pricing_utils';
import { FormattedMessage, injectIntl } from 'react-intl';

class CheckoutSummaryPricingSubtotal extends React.Component {
  static displayName = 'CheckoutSummaryPricingSubtotal';

  static propTypes() {
    return {
      subtotal: PropTypes.string.isRequired,
    };
  }

  static defaultProps = {
    displayIcon: true,
  };

  renderIcon = () => {
    if (this.props.displayIcon) {
      return (
        <button
          data-testid="summary-price-breakdown-arrow"
          type="button"
          className="CheckoutSummary-PriceBreakDown"
          aria-label="Expands pricing summary"
        >
          <span
            className="af-angle-down-2 brand-color"
            data-testid="down-arrow"
          />
        </button>
      );
    }
    return null;
  };

  render() {
    return (
      <table className="Subtotal section">
        <tbody>
          <tr>
            <td className="label">
              <span className="large">
                <FormattedMessage id="TOTAL" defaultMessage="Total" />:
              </span>
            </td>
            <td className="value">
              <span className="large" data-testid="total-amount">
                {' '}
                {roundPrice(this.props.amount)}
              </span>
              {this.renderIcon()}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default injectIntl(CheckoutSummaryPricingSubtotal);
